module.exports = __webpack_public_path__ + "media/images/emoticons/movie-20663558e6e13912e8d7e19bdf136026.gif";